import { render } from "./MiniMap.vue?vue&type=template&id=0ee80b6d"
import script from "./MiniMap.vue?vue&type=script&lang=js"
export * from "./MiniMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__